import Image from 'next/image';
import { FC } from 'react';
import ItemButton from 'src/components/common/ItemButton';
import useResponsive from 'src/hooks/contexts/useResponsive';
import Spacing from 'src/styles/layouts/Spacing';
import NGButton from 'src/styles/theme/components/NGButton';
import NGHeading from 'src/styles/theme/components/NGHeading';
import NGIcon from 'src/styles/theme/components/NGIcon';
import NGText from 'src/styles/theme/components/NGText';
import { ETextAlign, ETextType } from 'src/styles/theme/components/NGText/NGText.enum';
import { EMediaQuery, ESize } from 'src/styles/theme/utils/enums';
import { StyledImageContainer, StyledOverviewCard, StyledTextContainer } from './OverviewCard.styles';
import { IOverviewCard } from './OverviewCard.type';

const OverviewCard: FC<IOverviewCard> = ({
	title,
	description,
	appLink,
	targetSubmenu,
	imageSrc,
	icon,
	onClick,
	dataCy
}) => {
	const { isSmallerThanMd } = useResponsive();

	return (
		<StyledOverviewCard>
			<StyledImageContainer>
				<Image quality={100} src={imageSrc} alt={`${title} card`} layout='fill' objectFit='contain' draggable={false} />
				<NGIcon type={icon} size={ESize.xl} />
			</StyledImageContainer>

			<StyledTextContainer>
				<NGHeading as='h2' type={ETextType.h2} textAlign={ETextAlign.center}>
					{title}
				</NGHeading>

				<Spacing size={ESize.s} mdSize={ESize['2xs']} />

				<NGText size={ESize.m} mdSize={ESize.s}>
					{description}
				</NGText>

				<Spacing size={ESize.xs} mdSize={ESize.unset} />

				{!isSmallerThanMd ? (
					<NGButton
						hiddenRange={[EMediaQuery.md, undefined]}
						size={ESize.s}
						onClick={onClick ? () => onClick(appLink, targetSubmenu) : undefined}
						dataCy={dataCy}
					>
						{`Go to ${title}`}
					</NGButton>
				) : (
					<ItemButton
						onClick={onClick ? () => onClick(appLink, targetSubmenu) : undefined}
						ariaLabel={`Go to ${title}`}
						data-cy={dataCy}
					/>
				)}
			</StyledTextContainer>
		</StyledOverviewCard>
	);
};

export { OverviewCard };
